export const DEFAULT_HOME_CATEGORY_SECTION = {
  tag: "What We Print",
  title: "Browse Our Products",
  subtitle: "From business cards to large-format banners — everything your brand needs, printed perfectly.",
  cards: [
    {
      id: "business-cards",
      label: "Business Cards",
      link: "/products?group=Business%20Cards",
      imageCategoryNames: ["Business Cards", "Folded Business Cards", "Specialty Business Cards", "Plastics"],
    },
    {
      id: "print-products",
      label: "Print Products",
      link: "/products?group=Print%20Products",
      imageCategoryNames: ["Flyers", "Brochures", "Door Hangers", "Booklets", "Tear Cards", "Tent Cards", "Notepads", "Bookmarks", "Digital Sheets", "NCR Forms"],
    },
    {
      id: "stationery",
      label: "Stationery",
      link: "/products?group=Stationery",
      imageCategoryNames: ["Postcards", "Specialty Post Cards", "Greeting Cards", "Specialty Greeting Cards", "Invitations", "Wall Calendars"],
    },
    {
      id: "large-format",
      label: "Large Format",
      link: "/products?group=Large%20Format",
      imageCategoryNames: ["Posters", "Large Format Posters", "Vinyl Banners", "Pull Up Banners", "Pull Up Banners-", "X-Frame Banners"],
    },
    {
      id: "labels-packaging",
      label: "Labels & Packaging",
      link: "/products?group=Labels%20%26%20Packaging",
      imageCategoryNames: ["Square Cut Labels / Stickers", "Roll Labels / Stickers", "Clings", "Wall Decals", "Floor Graphics", "Window Graphics", "Adhesive Vinyl", "Car Magnets", "Magnets"],
    },
    {
      id: "promotions-apparel",
      label: "Promotions & Apparel",
      link: "/products?group=Promotions%20%26%20Apparel",
      imageCategoryNames: ["Letterhead", "Envelopes", "Presentation Folders", "Table Covers", "Supply Boxes", "Coroplast Signs & Yard Signs", "Coroplast Signs & Yard Signs-", "Aluminum Signs", "Styrene Signs", "Sintra/Rigid Board", "Foam Board", "Display Board / POP", "A Frame Stands", "A-Frame Signs", "H Stands for Signs", "Canvas"],
    },
  ],
};
